import { z } from 'zod';
const UpdateIngredientItemSchema = z.object({
    name: z.string().describe('Name of the ingredient to update'),
    pricePerUnit: z.number().nullable().describe('New price per unit if it has changed'),
});
export const UpdateIngredientRequestSchema = z.object({
    updates: z.array(UpdateIngredientItemSchema).describe('Array of ingredient updates to apply'),
});
//# sourceMappingURL=UpdateIngredientRequestSchema.js.map